import React, { Component } from 'react'

// Components
import ProfileSlider from '../../../components/Profile/ProfileSlider/ProfileSlider'
import ProfileTabSection from '../../../components/Profile/ProfileTabSection'

class PlayerProfileProfile extends Component {
  render() {
    const {
      videos,
      photos
    } = this.props.participation

    return videos.length > 0 || photos.length > 0
    ? (
      <div className="player-profile-profile">
        { videos.length > 0 &&
          <div className="player-profile-profile-content-section">
            <div className="inner-wrap">
              <h2 className="player-profile-heading">
                Highlights
              </h2>
            </div>
            <ProfileSlider slides={videos} />
          </div>
        }
        { photos.length > 0 &&
          <div className="player-profile-profile-content-section">
            <div className="inner-wrap">
              <h2 className="player-profile-heading">
                Photos
              </h2>
            </div>
            <ProfileSlider slides={photos.map(p => p.url)} images={true} />
          </div>
        }
      </div>
    )
    : (
      <ProfileTabSection>
        <div className="empty-state-message">
          This user hasn't filled out their profile... yet
        </div>
      </ProfileTabSection>
    )
  }
}

export default PlayerProfileProfile



// WEBPACK FOOTER //
// ./src/screens/Profile/ProfileSections/PlayerProfileProfile.js